import { createContext } from 'react';
import { AuthProps } from '../types/props';

const domain = process.env.REACT_APP_DOMAIN || '';
const clientId = process.env.REACT_APP_CLIENT_ID || '';

const authProps: AuthProps = {
  domain,
  clientId,
};

export const AuthContext = createContext(authProps);
